module.exports = __webpack_public_path__ + "static/img/get_un_purse.d6b2d955.png";